export const MODALS = {
  saveClassModal: "SAVE_CLASS_MODAL",
};